import React, {useState} from "react";
import PropTypes from "prop-types";
import {FormProvider, useForm} from "react-hook-form";
import styled, {css} from "styled-components";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";

// Components
import {InputTextArea} from "../../components/form/FormInputs.js";
import Modal from "../../components/Modal.js";

// Style
import {pad} from "../../style/components/variables.js";
import {
  Form,
  FormField,
  Inline,
  Button,
  HeadingCenter,
  ButtonLoader
} from "../../style/components/general.js";

const ModalRecordVersionNote = ({visible, setVisible, submitNote, cancel}) => {
  const schema = yup.object().shape({
    note: yup.string().nullable().required()
  });

  const [loading, setLoading] = useState(false);

  const form = useForm({
    defaultValues: {
      note: ""
    },
    resolver: yupResolver(schema)
  });

  const {handleSubmit} = form;

  const submit = ({note}) => {
    setLoading(true);
    submitNote(note).then(() => {
      setLoading(false);
    });
  };

  return (
    <Modal visible={visible} setVisible={setVisible}>
      <ModalTitle>Reason for Update</ModalTitle>
      <FormProvider {...form}>
        <Form onSubmit={handleSubmit(submit)} noValidate>
          <FormField>
            <InputTextArea
              name="note"
              label="Explanation"
              testId="addNote.message"
              maxLength={1000}
            />
          </FormField>

          <ButtonWrapper>
            <SubmitButton type="submit" loading={loading ? 1 : 0}>
              Save
              {loading && <ButtonLoader />}
            </SubmitButton>
            <Button type="button" onClick={() => cancel()}>
              Cancel
            </Button>
          </ButtonWrapper>
        </Form>
      </FormProvider>
    </Modal>
  );
};

ModalRecordVersionNote.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  submitNote: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired
};

// Style Overrides
const ModalTitle = styled(HeadingCenter)`
  margin-bottom: ${pad * 2}px;
`;

const ButtonWrapper = styled(Inline)`
  gap: ${pad}px;
  margin-top: ${pad}px;
`;

const SubmitButton = styled(Button)`
  ${({loading}) =>
    loading &&
    css`
      background: rgba(0, 0, 0, 0.5);
      pointer-events: none;
    `};
`;

export default ModalRecordVersionNote;
